var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.renderComponent === true)?_c('FormMange',{attrs:{"tab":true,"formProps":_vm.formProps,"startupIdProps":null,"batchData":_vm.batch,"demo":false,"isLockForm":null}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }